import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import '../../../../../App.css'
import { numberMasking } from '../../../../../data/config'
import useMutationApi from '../../../../../hooks/useMutation'
import { RESEND_OTP, RESET_MPIN, VERIFY_FORGOT_MPIN_OTP, } from '../../../GraphQLQuries/Auth'
import { useDispatch, useSelector } from 'react-redux'
import { actionsUsers } from '../../../../../setup/redux/rootReducer'
import { toNumber } from 'lodash'
import { LoadingSpinner } from '../../../../../_ePulse/layout/components/LoadingSpinner'
import { toast } from 'react-toastify'
import { ToastMessageContainer } from '../../../../../_ePulse/layout/components/ToastMessageContainer'


const initialValues = {
  otp: '',
  mpin: '',
  confirmMpin: ''
};

const resetSchema = Yup.object().shape({
  otp: Yup.string().required('OTP is required'),
  mpin: Yup.string().required('MPIN is required'),
  confirmMpin: Yup.string().required('MPIN is required')
});


export function NewMPIN_OTP() {
  const navigate = useNavigate();
  const location = useLocation()
  useEffect(() => {
    if (!location.state) {
      navigate('/auth', { replace: true })
    }
  }, [])
  const browsingDetails = useSelector((state: any) => state.browsingDetails)
  const {mobileNumber, mpinLength, countryCode, resendOtpTime }: any = (location?.state || {});
  const [ isOtpVerified, setIsOtpVerified ] = useState( false ); 
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [Errors, setErrors] = useState<string | undefined>(undefined);
  const [minutes, setMinutes] = useState(Number(resendOtpTime?.replace('m', '') || 0))
  const [seconds, setSeconds] = useState(0)
  const {createData: verifyForgotOtp, data, error} = useMutationApi(VERIFY_FORGOT_MPIN_OTP);
  const {createData: resendOTP} = useMutationApi(RESEND_OTP);
  const {createData} = useMutationApi(RESET_MPIN);
  const dispatch = useDispatch()



  const formik = useFormik({
    initialValues,
    validationSchema: resetSchema,
    onSubmit: async (values) => {
      setLoading(true)
      setHasErrors(undefined)
      try {
        const otp = toNumber( values.otp);
        const res = await createData({
          mobileNumber,
          countryCode : countryCode.toString(),
          otp: otp,
          newMpin: values.mpin,
          confirmNewMpin: values.confirmMpin
        })        
        toast.success(res?.data?.resetMpin);
        dispatch(
          actionsUsers.updateUser({
            mobile_number: mobileNumber,
          })
        )
        navigate(`/auth/mpin`, {
          state: {
            browserUniqueId: browsingDetails.browserUniqueId,
            ipAddress: browsingDetails.ipAddress,
            userAgent: browsingDetails?.userAgent,
            browserName: browsingDetails.browserName,
            countryCode: countryCode,
            mpinLength: mpinLength,
          },
        })
        setLoading(false)
        setHasErrors(undefined);
      } catch (error: any) {
        setHasErrors(true);
        setErrors(error?.message ? error.message : 'Sorry, looks like there are some errors detected, please try again.');
      }
      finally{
        setLoading(false);
      }
    },
  })

  const verifyOtp = async() => {
    try{
      setLoading(true);
      const res = await verifyForgotOtp({
        countryCode: countryCode,
        mobileNumber: mobileNumber,
        otp: formik.values.otp,
        type: "OTP",
        ipAddress: browsingDetails.ipAddress,
        userAgent: browsingDetails?.userAgent,
        browserName: browsingDetails.browserName,
        browserUniqueId: browsingDetails.browserUniqueId,
        deviceType: "web"
      });
      setIsOtpVerified( res?.data?.verifyForgotMpinOtp?.success);
      setHasErrors(undefined);
    }
    catch(error: any){
      setHasErrors(true);
      setErrors(error.message ?? 'Sorry, looks like there are some errors detected, please try again.')
    }
    finally{
      setLoading(false);
    }
  }

  const resendOtp = async() => {
    try{
      setLoading(true);
      const res = await resendOTP({
        countryCode,
        mobileNumber
      });
      if (process.env.REACT_APP_ENV !== 'PROD') {
        //OTP TOAST
        alert(res?.data?.resendOtp)
      }
      toast.success("OTP sent successfully on registered mobile number.");
      setHasErrors(undefined);
    }
    catch(error: any ) {
      setHasErrors(true);
      setErrors(error.message ?? 'Sorry, looks like there are some errors detected, please try again.')
    }
    finally{
      setLoading(false);
    }
  }


  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval)
        } else {
          setSeconds(59)
          setMinutes(minutes - 1)
        }
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [seconds])

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <ToastMessageContainer/>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Enter OTP & New MPIN</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>
            Otp send to {numberMasking(mobileNumber)}
          </div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              {Errors}
            </div>
          </div>
        )}

        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
        { !isOtpVerified && 
          <>
            <label className='form-label fs-6 fw-bolder text-dark'>OTP</label>
            <input
              placeholder='Enter OTP'
              {...formik.getFieldProps('otp')}
              className={clsx('form-control form-control-lg form-control-solid')}
              type='text'
              name='otp'
              autoComplete='off'
              maxLength={6}
              disabled={isOtpVerified}
              />
            {formik.touched.otp && formik.errors.otp && (
              <div className='fv-plugins-message-container'>
                <span className='text-danger'>{formik.errors.otp}</span>
              </div>
            )}
          </>
          }
          {isOtpVerified && (
            <>
              <label className='form-label fs-6 fw-bolder text-dark'>MPIN</label>
              <input
                placeholder='Enter MPIN'
                {...formik.getFieldProps('mpin')}
                className={clsx('form-control form-control-lg form-control-solid')}
                type='text'
                name='mpin'
                autoComplete='off'
                maxLength={mpinLength}
              />
              {formik.touched.mpin && formik.errors.mpin && (
                <div className='fv-plugins-message-container'>
                  <span className='text-danger'>{formik.errors.mpin}</span>
                </div>
              )}

              <label className='form-label fs-6 fw-bolder text-dark'>Confirm MPIN</label>
              <input
                placeholder='Enter Confirm MPIN'
                {...formik.getFieldProps('confirmMpin')}
                className={clsx('form-control form-control-lg form-control-solid')}
                type='text'
                name='confirmMpin'
                autoComplete='off'
                maxLength={mpinLength}
              />
              {formik.touched.confirmMpin && formik.errors.confirmMpin && (
                <div className='fv-plugins-message-container'>
                  <span className='text-danger'>{formik.errors.confirmMpin}</span>
                </div>
              )}
            </>
          )}
        </div>
        {/* end::Form group */}
        {!isOtpVerified && (
          <div className='d-flex flex-row justify-content-between mb-3 align-items-center'>
            {seconds > 0 || minutes > 0 ? (
              <p>
                Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                {seconds < 10 ? `0${seconds}` : seconds}
              </p>
            ) : (
              <p>Didn't recieve code?</p>
            )}

            <button
              type='button'
              disabled={seconds > 0 || minutes > 0}
              // style={
              //   {
              //     // color: seconds > 0 || minutes > 0 ? '#DFE3E8' : '#FF5630',
              //   }
              // }
              className={
                seconds > 0 || minutes > 0 ? 'ePulse-button-disabled' : 'ePulse-button-secondory'
              }
              onClick={() => resendOtp()}
            >
              Resend OTP
            </button>
          </div>
        )}
        {/* begin::Form group */}
        <div className='d-flex flex-column justify-content-center align-items-center '>
          { !isOtpVerified && 
            <button
              type='button'
              id='kt_password_reset_submit'
              className='border-0 fw-bolder me-4 rounded-pill ePulse-appColor-primary col-10 py-2'
              onClick={verifyOtp}
              >
              <span className='indicator-label text-white'>Verify OTP</span>
              {loading && (
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          }
          { isOtpVerified &&
            <button
              type='submit'
              id='kt_password_reset_submit'
              className='border-0 fw-bolder me-4 rounded-pill ePulse-appColor-primary col-10 py-2'
              >
              <span className='indicator-label text-white'>Update MPIN</span>
              {loading && (
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          }

          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='border-0 rounded-pill btn-light-white fw-bolder col-10 py-2 mt-4 ePulse-textColor-primary'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            <Link to='/auth' className='ePulse-textColor-primary'>
              Go back to login
            </Link>
          </button>
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
